import { useContext, useCallback } from "react"
import AuthContext from "store/context/PublicContext"
import { AppContext } from "store/context/AppContext"
import useCancelToken from "hooks/useCancelToken"
import { put_module_entity_action_middleware_without_bff } from "services/middleware_services"
import OMNIX_MODULE from "constants/OMNIX_MODULE"

interface IPutInventoryParams {
  source_id: string
  body: {
    op: string
    items: Array<{
      sku: string
      quantity: number
    }>
  }
}

const useInventoryResources = () => {
  const { newCancelToken } = useCancelToken()
  const {
    user: { token },
  } = useContext(AuthContext)
  const { loading_app, set_loading_app } = useContext(AppContext)

  const put_adjust_inventory_action = useCallback(
    async ({ source_id, body }: IPutInventoryParams) => {
      return await put_module_entity_action_middleware_without_bff(
        OMNIX_MODULE.OIM,
        `inventory/item/all/source/${source_id}`,
        body,
        token,
        newCancelToken(),
      )
    },
    [token, newCancelToken],
  )

  return {
    put_adjust_inventory_action,
    loading_app,
    set_loading_app,
  }
}

export default useInventoryResources
